import React, { Component } from "react";
import { PageHeader, ListGroup, ControlLabel,  Glyphicon } from "react-bootstrap";
import "./Friend.css";
import { API } from "aws-amplify";
import LibraryBookItem from "../components/LibraryBookItem";


export default class Friend extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: true
			, books: null
		};
	}

	async componentDidMount() {
		if (!this.props.isAuthenticated) {
			this.props.history.push("/login");
		}
		const userid = this.props.match.params.userid


		try {
			const books = await API.get("books", "friend/" + userid.replace(":","_"))
				.catch(error => {
					console.log("API Friend error:",error);
					this.onLoginError({message:"Unable to access Friends list, please try again later (" + error.error + ")"})

				}); //this.GetUserBooks();
			console.log("Searched books:", books);
			if (books !== undefined) {
				for (var i = 0; i < books.Count; i++) {
					console.log("Found Book, setting info:" + books.Items[i].ISBN);
					//books.Items[i].Info = await this.bookSearch(books.Items[i].ISBN);
				}
				this.setState({ books });
			}
		} catch (e) {
			alert(e);
		}

		this.setState({ isLoading: false });
	}

	GetUserBooks() {
		console.log("Obtaining books.");
		var result = API.get("books", "user/books");
		console.log("Books returned:", result);
		if (result === "No credentials.")
			this.props.history.push('/login');
		return result;
	}

	bookSearch(ISBN) {
		var info = 'test'; //API.get("books", "search", {'ISBN': ISBN});

		return info;
	}
	popUpBook = function (data) {
		console.log('Popup Book: ', data);
		//var response = API.post("books", "user/book", {body : {'ISBN': data.volumeInfo.industryIdentifiers[0].identifier,'Info': data}});
		//console.log('response: ', response);
		return false;
	}

	showBookRequests = function (data) {
		console.log('Request Book: ', data);
		console.log('Request Total: ', data.length);
		console.log('Request Total2: ', Object.keys(data).length);
		//var response = API.post("books", "user/book", {body : {'ISBN': data.volumeInfo.industryIdentifiers[0].identifier,'Info': data}});
		//console.log('response: ', response);
		return false;
	}

	renderBooksList() {
		if (!this.state.books) return;
		let books = this.state.books.Items;
		return [{}].concat(books)
			.map(
				(book, i) =>
					(i !== 0) ?
						<LibraryBookItem key={i} src={book} />
						: ""
			);
	}

	handleBookClick = event => {
		event.preventDefault();
		console.log('handleBookClick: ', event.currentTarget);

		this.props.history.push('/user/books/' + event.currentTarget.getAttribute("src"));
	}

	renderLander() {
		return (
			<div className="lander">
				<h1>Bukhu</h1>
				<p>Share Your Treasure</p>
			</div>
		);
	}

	renderBooks() {
		return (
			<div className="books">
				<PageHeader>{this.state.isLoading && <Glyphicon glyph="refresh" className="spinning" />}Your Friend's Books</PageHeader>

				{this.state.isLoading ? <ControlLabel key="0">Loading</ControlLabel> : this.state.books ? "" : <ControlLabel key="0">Your Friend's Library is empty</ControlLabel>}
				<ListGroup>

					{!this.state.isLoading && this.renderBooksList()}
				</ListGroup>
			</div>
		);
	}

	render() {
		return (
			<div className="Friend">
				{this.props.isAuthenticated ? this.renderBooks() : this.renderLander()}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/Friend.js